module.exports = __webpack_public_path__ + "img/20191111165617409.09c7e6b1.jpg";